// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"fa17c608","235":"f314e6ed","606":"b92afa19","616":"cbc53b65","617":"f314e6ed","818":"fa2edb0d","868":"cbc53b65"}[chunkId] + ".chunk.css";
};